import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  NodesState,
  Node,
  NodesListData,
} from '../../types/nodes.types';

const initialState: NodesState = {
  nodes: [],
  selectedNode: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const nodesSlice = createSlice({
  name: 'nodes',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setNodes: (state, action: PayloadAction<NodesListData>) => {
      state.nodes = action.payload.nodes;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedNode: (state, action: PayloadAction<Node | null>) => {
      state.selectedNode = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedNode: (state) => {
      state.selectedNode = null;
    },
    addNode: (state, action: PayloadAction<Node>) => {
      state.nodes.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateNode: (state, action: PayloadAction<Node>) => {
      const index = state.nodes.findIndex((n) => n.id === action.payload.id);
      if (index !== -1) {
        state.nodes[index] = action.payload;
      }
      if (state.selectedNode?.id === action.payload.id) {
        state.selectedNode = action.payload;
      }
    },
    deleteNode: (state, action: PayloadAction<string>) => {
      state.nodes = state.nodes.filter((n) => n.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedNode?.id === action.payload) {
        state.selectedNode = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setNodes,
  setSelectedNode,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedNode,
  addNode,
  updateNode,
  deleteNode,
} = nodesSlice.actions;

export default nodesSlice.reducer;
